module.exports = __webpack_public_path__ + "files/76c318bbd371b8eb92615051330ad27f.png";